"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryMediaStrategy = void 0;
var MediaStrategy_1 = require("./MediaStrategy");
var testUtils_1 = require("../testUtils");
var MediaItem_1 = require("../MediaItem");
var sleep_1 = require("../sleep");
var InMemoryMediaStrategy = /** @class */ (function (_super) {
    __extends(InMemoryMediaStrategy, _super);
    function InMemoryMediaStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InMemoryMediaStrategy.prototype.handleLoadMediaItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.seedMediaItems();
                if (!InMemoryMediaStrategy.mediaItems)
                    throw Error('mediaItems is null');
                return [2 /*return*/, InMemoryMediaStrategy.mediaItems];
            });
        });
    };
    InMemoryMediaStrategy.prototype.handleLoadMediaItem = function (type, id) {
        return __awaiter(this, void 0, void 0, function () {
            var mediaItem;
            return __generator(this, function (_a) {
                this.seedMediaItems();
                if (!InMemoryMediaStrategy.mediaItems)
                    throw Error('mediaItems is null');
                mediaItem = InMemoryMediaStrategy.mediaItems.find(function (item) {
                    return (item.type === type && (0, MediaItem_1.isGuideImage)(item) && item.imageid === id) ||
                        ((0, MediaItem_1.isDocument)(item) && item.documentid === id) ||
                        ((0, MediaItem_1.isGuideVideoObject)(item) && item.objectid === id) ||
                        ((0, MediaItem_1.isGuideEmbedObject)(item) && item.objectid === id);
                });
                if (!mediaItem)
                    throw Error("Media Item Not Found: ".concat(type, "#").concat(id));
                return [2 /*return*/, mediaItem];
            });
        });
    };
    InMemoryMediaStrategy.prototype.handleLoadImageDetails = function (imageid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, __assign(__assign({}, InMemoryMediaStrategy.imageDetails), { image: __assign(__assign({}, InMemoryMediaStrategy.imageDetails.image), { id: imageid }) })];
            });
        });
    };
    InMemoryMediaStrategy.prototype.seedMediaItems = function () {
        var _a;
        InMemoryMediaStrategy.mediaItems = (_a = InMemoryMediaStrategy.mediaItems) !== null && _a !== void 0 ? _a : [
            (0, testUtils_1.mockGuideImage)(),
            (0, testUtils_1.mockGuideImage)(),
            (0, testUtils_1.mockGuideImage)(),
            (0, testUtils_1.mockGuideVideoObject)(),
            (0, testUtils_1.mockGuideEmbedObject)(),
            (0, testUtils_1.mockDocument)(),
        ];
        return InMemoryMediaStrategy.mediaItems;
    };
    InMemoryMediaStrategy.prototype.handleLoadMediaConstraints = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Simulate a delay for loading constraints
                    return [4 /*yield*/, (0, sleep_1.sleep)(InMemoryMediaStrategy.constraintsDelay)];
                    case 1:
                        // Simulate a delay for loading constraints
                        _a.sent();
                        return [2 /*return*/, InMemoryMediaStrategy.mediaConstraints];
                }
            });
        });
    };
    InMemoryMediaStrategy.prototype.handleAllMediaItemsDeleted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                InMemoryMediaStrategy.mediaItems = [];
                return [2 /*return*/];
            });
        });
    };
    InMemoryMediaStrategy.prototype.handleUpload = function (tempId, file, onProgress, imageOptions) {
        if (imageOptions === void 0) { imageOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var item, completedItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item = (0, testUtils_1.mockUploadingMediaItem)(tempId, 'uploading', 0, file);
                        return [4 /*yield*/, this.handleMockUpload(item, tempId, onProgress)];
                    case 1:
                        _a.sent();
                        completedItem = (0, testUtils_1.mockGuideImage)(imageOptions);
                        if (file.type === 'application/pdf') {
                            completedItem = (0, testUtils_1.mockDocument)();
                        }
                        completedItem.filename = file.name;
                        onProgress(tempId, completedItem);
                        return [2 /*return*/];
                }
            });
        });
    };
    InMemoryMediaStrategy.prototype.handleImportImageByUrl = function (tempId, url, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var item, completedItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item = (0, testUtils_1.mockUploadingMediaItem)(tempId, 'uploading', 0);
                        return [4 /*yield*/, this.handleMockUpload(item, tempId, onProgress)];
                    case 1:
                        _a.sent();
                        completedItem = (0, testUtils_1.mockGuideImage)();
                        onProgress(tempId, completedItem);
                        return [2 /*return*/];
                }
            });
        });
    };
    InMemoryMediaStrategy.prototype.handleImportEmbedByUrl = function (tempId, url, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var item, completedItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item = (0, testUtils_1.mockUploadingMediaItem)(tempId, 'uploading', 0);
                        return [4 /*yield*/, this.handleMockUpload(item, tempId, onProgress)];
                    case 1:
                        _a.sent();
                        completedItem = (0, testUtils_1.mockGuideImage)();
                        onProgress(tempId, completedItem);
                        return [2 /*return*/];
                }
            });
        });
    };
    InMemoryMediaStrategy.prototype.handleMediaItemDeleted = function (mediaItem) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, sleep_1.sleep)(500)];
                    case 1:
                        _a.sent();
                        this.setState(function (state) { return (__assign(__assign({}, state), { mediaItems: state.mediaItems.filter(function (item) { return item !== mediaItem; }) })); });
                        return [2 /*return*/];
                }
            });
        });
    };
    InMemoryMediaStrategy.prototype.handleCopyMediaItem = function (mediaItem) {
        return __awaiter(this, void 0, void 0, function () {
            var newMediaItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, sleep_1.sleep)(500)];
                    case 1:
                        _a.sent();
                        newMediaItem = __assign({}, mediaItem);
                        this.setState(function (state) {
                            var newItems = state.mediaItems.map(function (obj) { return (__assign({}, obj)); });
                            if ((0, MediaItem_1.isNotUploadingMediaItem)(newMediaItem)) {
                                newMediaItem.imageid += (0, testUtils_1.mockGuideImage)().imageid;
                            }
                            if ((0, MediaItem_1.isGuideVideoObject)(newMediaItem) || (0, MediaItem_1.isGuideEmbedObject)(newMediaItem)) {
                                newMediaItem.objectid += (0, testUtils_1.mockGuideVideoObject)().objectid;
                            }
                            newItems.push(newMediaItem);
                            return __assign(__assign({}, state), { mediaItems: newItems });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    InMemoryMediaStrategy.prototype.handleMockUpload = function (item, tempId, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        onProgress(tempId, item);
                        return [4 /*yield*/, (0, sleep_1.sleep)(500)];
                    case 1:
                        _a.sent();
                        item = __assign(__assign({}, item), { progress: 0.5 });
                        onProgress(tempId, item);
                        return [4 /*yield*/, (0, sleep_1.sleep)(500)];
                    case 2:
                        _a.sent();
                        item = __assign(__assign({}, item), { progress: 1 });
                        onProgress(tempId, item);
                        return [4 /*yield*/, (0, sleep_1.sleep)(500)];
                    case 3:
                        _a.sent();
                        item = __assign(__assign({}, item), { progress: null, step: 'processing' });
                        onProgress(tempId, item);
                        return [4 /*yield*/, (0, sleep_1.sleep)(500)];
                    case 4:
                        _a.sent();
                        item = __assign(__assign({}, item), { progress: 1, step: 'processing' });
                        onProgress(tempId, item);
                        return [4 /*yield*/, (0, sleep_1.sleep)(500)];
                    case 5:
                        _a.sent();
                        item = __assign(__assign({}, item), { progress: 1, step: 'complete' });
                        onProgress(tempId, item);
                        return [4 /*yield*/, (0, sleep_1.sleep)(300)];
                    case 6:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InMemoryMediaStrategy.prototype.handleEditedImageUpload = function (tempId, options, file, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var imageid, item, completedItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageid = options.imageid;
                        item = (0, testUtils_1.mockUploadingMediaItem)(tempId, 'uploading', 0, file);
                        return [4 /*yield*/, this.handleMockUpload(item, tempId, onProgress)];
                    case 1:
                        _a.sent();
                        completedItem = (0, testUtils_1.mockGuideImage)({ srcid: imageid });
                        completedItem.filename = file.name;
                        onProgress(tempId, completedItem);
                        return [2 /*return*/, completedItem];
                }
            });
        });
    };
    InMemoryMediaStrategy.mediaItems = null;
    InMemoryMediaStrategy.mediaConstraints = null;
    InMemoryMediaStrategy.constraintsDelay = 0;
    InMemoryMediaStrategy.imageDetails = {
        image: {
            id: 32,
            original: 'https://sharrington3.sharrington.dozuki.dev/igi/sharrington3/FLIeGZRLo2CJCGWU.full',
        },
        srcid: null,
        width: 960,
        height: 1280,
        ratio: 'VARIABLE',
        markup: undefined,
        markupState: undefined,
        exif: { FileName: 'faribault.jpg' },
        encoding: 'jpeg',
        srcImageInfo: {
            image: {
                id: 25,
                original: 'https://sharrington3.sharrington.dozuki.dev/igi/sharrington3/FLIeGZRLo2CJCGWU.full',
            },
            srcid: null,
            width: 960,
            height: 1280,
            ratio: 'VARIABLE',
            markup: undefined,
            markupState: undefined,
            exif: { FileName: 'faribault.jpg' },
            encoding: 'jpeg',
        },
        filterInfo: {
            ratio: 'VARIABLE',
        },
    };
    return InMemoryMediaStrategy;
}(MediaStrategy_1.MediaStrategy));
exports.InMemoryMediaStrategy = InMemoryMediaStrategy;
